import { useMemo } from "react";
import { useQuery } from "@apollo/client";
import { GET_SYSTEMS, GET_ASSESSMENT, GET_USERS } from "../../../../../apis/settingsApis/access-apis/accessApis";
import { SystemKey, IntegrationType } from "../../../../../utils/enums";
export const useReviewData = (systemId, assessmentId, isEmbedded) => {
  const { data: systemsData, loading: systemLoading, refetch: refetchSystems } = useQuery(GET_SYSTEMS, {
    variables: {
      page: 1,
      limit: 1000,
    },
    fetchPolicy: "cache-and-network",
  });

  const filteredSystemsData = useMemo(() => {
    if (!systemsData?.getSystems?.data) return systemsData;
    return {
      ...systemsData,
      getSystems: {
        ...systemsData.getSystems,
        data: systemsData.getSystems.data.filter((s) => {
          const isZohoPeople = s.key?.toLowerCase() === SystemKey?.ZOHO_PEOPLE;
          return !isZohoPeople || (isZohoPeople && (s.integration_type || '').toUpperCase() === IntegrationType.MANUAL);
        }),
      },
    };
  }, [systemsData]);

  const {
    data: assessmentData,
    loading: assessmentsLoading,
    refetch: refetchAssessments,
  } = useQuery(GET_ASSESSMENT, { 
    variables: isEmbedded ? {
      page: 1, 
      limit: 1000,
      filter: {
        resource_id: parseInt(systemId)
      }
    } : {
      page: 1, 
      limit: 1,
      filter: {
        id: [parseInt(assessmentId)]
      }
    },
    skip: isEmbedded ? !systemId : !assessmentId,
    fetchPolicy: "cache-and-network",
  });

  const allAssessments = useMemo(() => assessmentData?.getAssessment?.data || [], [assessmentData]);
  
  const currentSystem = useMemo(() => {
    const systems = filteredSystemsData?.getSystems?.data || [];
    return systems.find((s) => s.id === parseInt(systemId));
  }, [filteredSystemsData, systemId]);

  const firstAssessment = allAssessments[0];
  const currentSystemId = useMemo(() => {
    return firstAssessment?.resource_id || (currentSystem ? parseInt(currentSystem.id) : null);
  }, [firstAssessment, currentSystem]);

  const {
    data: usersData,
    loading: loadingUsers,
    refetch: refetchUsersData,
  } = useQuery(GET_USERS, {
    variables: {
      page: 1,
      limit: 1000,
      filter: {
        resource_id: currentSystemId ? [currentSystemId] : [],
        ...(firstAssessment?.id && { assessment_id: firstAssessment.id }),
      },
    },
    skip: !currentSystemId,
    fetchPolicy: "network-only",
  });

  const users = useMemo(() => usersData?.getUsers?.data || [], [usersData]);

  return {
    systemLoading,
    assessmentsLoading,
    loadingUsers,
    refetchSystems,
    refetchAssessments,
    refetchUsersData,
    allAssessments,
    currentSystem,
    users,
  };
};

